interface LookupRequest {
  query: string;
  context: string;
  language: string;
  explanationLanguage: string;
}

const definitionCacheKey = (lookupRequest: LookupRequest) =>
  [
    lookupRequest.query,
    lookupRequest.context,
    lookupRequest.language,
    lookupRequest.explanationLanguage,
  ].join("\n");

/** null means the user dismissed explanations for this word + context */
const definitionCache: { [key: string]: string | null } = {};

export const cacheGet = (lookupRequest: LookupRequest) =>
  definitionCache[definitionCacheKey(lookupRequest)];

export const cacheSet = (
  lookupRequest: LookupRequest,
  definition: string | null
) => {
  definitionCache[definitionCacheKey(lookupRequest)] = definition;
};
